import { callApi } from './api';

import { Office } from '@/types/office';

export const updateOffice = async (officeID: number, requestBody: Office) => {
  const { status, result } = await callApi<Office>(
    `offices/${officeID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
